import { useCallback, useEffect, useState } from 'react'
import { isBoolean, isObject } from 'query-types'

function isJSON(val) {
  try {
    const obj = JSON.parse(val)
    if (obj && typeof obj === 'object' && obj !== null) {
      return true
    }
  } catch (err) {
    return false
  }
}

export function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(
    (!!isJSON(localStorage.getItem(key)) &&
      JSON.parse(localStorage.getItem(key))) ||
      initialValue,
  )

  const setCfg = useCallback(
    (val) => {
      const currentState = isJSON(localStorage.getItem(key))
        ? JSON.parse(localStorage.getItem(key))
        : localStorage.getItem(key)

      const merged =
        !!currentState && isObject(currentState)
          ? { ...currentState, ...val }
          : isBoolean(val)
          ? val === 'true'
          : val

      setValue(merged)

      localStorage.setItem(key, JSON.stringify(merged))
    },
    [setValue],
  )

  useEffect(() => {
    if (!localStorage.getItem(key)) {
      setCfg(initialValue)
    } else {
      if (isJSON(localStorage.getItem(key))) {
        setValue(JSON.parse(localStorage.getItem(key)))
      } else {
        if (isBoolean(localStorage.getItem(key))) {
          setCfg(localStorage.getItem(key) === 'true')
        }
        setCfg(localStorage.getItem(key))
      }
    }
  }, [])

  return [value, setCfg]
}
